import { WEEKDAYS_VN } from "../XoSoCompound/constants";

export { WEEKDAYS_VN };

export const TZ = "Asia/Ho_Chi_Minh";

export const GAME_MEGA = "MEGA_6_45";
export const GAME_POWER = "POWER_6_55";

export const GAME_ORDER = [GAME_MEGA, GAME_POWER];

const GAME_ALIASES = {
  all: "all",
  "*": "all",
  vietlott: "all",
  mega: GAME_MEGA,
  "mega-6-45": GAME_MEGA,
  "mega-6x45": GAME_MEGA,
  mega645: GAME_MEGA,
  mega6x45: GAME_MEGA,
  mega_6_45: GAME_MEGA,
  mega_6x45: GAME_MEGA,
  [GAME_MEGA.toLowerCase()]: GAME_MEGA,
  power: GAME_POWER,
  "power-6-55": GAME_POWER,
  "power-6x55": GAME_POWER,
  power655: GAME_POWER,
  power6x55: GAME_POWER,
  power_6_55: GAME_POWER,
  power_6x55: GAME_POWER,
  [GAME_POWER.toLowerCase()]: GAME_POWER,
};

export const GAME_TITLES = {
  all: "Kết quả xổ số điện toán Vietlott",
  [GAME_MEGA]: "Kết quả xổ số Mega 6/45",
  [GAME_POWER]: "Kết quả xổ số Power 6/55",
};

export function resolveVietlottGames(category) {
  const key = String(category || "all").trim().toLowerCase();
  const resolved = GAME_ALIASES[key] ?? "all";
  if (resolved === "all") return GAME_ORDER;
  return [resolved];
}

export const GAME_META = {
  [GAME_MEGA]: {
    key: GAME_MEGA,
    label: "Mega 6/45",
    title: "MEGA 6/45",
    prizeRows: [
      { key: "jackpot", label: "Jackpot", matches: 6 },
      { key: "prize1", label: "Giải nhất", matches: 5 },
      { key: "prize2", label: "Giải nhì", matches: 4 },
      { key: "prize3", label: "Giải ba", matches: 3 },
    ],
  },
  [GAME_POWER]: {
    key: GAME_POWER,
    label: "Power 6/55",
    title: "POWER 6/55",
    prizeRows: [
      { key: "jackpot", label: "Jackpot 1", matches: 6 },
      { key: "jackpot2", label: "Jackpot 2", matches: 6, specialLast: true },
      { key: "prize1", label: "Giải nhất", matches: 5 },
      { key: "prize2", label: "Giải nhì", matches: 4 },
      { key: "prize3", label: "Giải ba", matches: 3 },
    ],
  },
};

export function formatMoney(value) {
  if (value == null || value === "") return "—";
  return Number(value).toLocaleString("en-US");
}

export function formatBall(n) {
  return String(n ?? "").padStart(2, "0");
}

export function formatDrawId(id) {
  if (!id) return "";
  const raw = String(id).replace(/^#/, "");
  return `#${raw.padStart(5, "0")}`;
}
